/**
 * Which merchant a page belongs to, read from the Next route rather than from the raw URL.
 *
 * Next resolves `[slug]` after stripping any locale prefix, so a locale-prefixed URL needs no
 * special handling here — reading `window.location.pathname` would have to know all fourteen
 * locales. `pages/forms/[slug]` has a `slug` param too, but it is a form id, so the route
 * *template* is checked before the value is trusted.
 *
 * Shared by the client (`lib/ga.ts`, via the Router singleton) and the server (`pages/_document`,
 * via the document context) so the two can never disagree about which merchant a page belongs to.
 */
export const BRAND_ROUTE_PREFIX = '/[slug]';

export const brandSlugFromRoute = (route?: string, query?: any, asPath?: string): string | undefined => {
  try {
    if (!route?.startsWith(BRAND_ROUTE_PREFIX)) return undefined;

    const fromQuery = query?.slug;
    if (typeof fromQuery === 'string' && fromQuery) return fromQuery;

    // `query` is still empty on a statically-optimised page until the router is ready. `asPath`
    // carries the real URL, locale prefix already stripped by Next.
    return (asPath || '').split(/[?#]/)[0].split('/').filter(Boolean)[0];
  } catch {
    return undefined;
  }
};
